@for (annotation of annotations(); track annotation.uuid) {
  <app-annotation-card
    [annotation]="annotation">
  </app-annotation-card>
}
@if (annotationsQuery.isLoading()) {
  <fw-progress-spinner></fw-progress-spinner>
}
